import { render, staticRenderFns } from "./EntryWrapper.vue?vue&type=template&id=bf548f14&"
import script from "./EntryWrapper.vue?vue&type=script&lang=js&"
export * from "./EntryWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports